import { createFileRoute } from '@tanstack/react-router';
import { CalendarIndex } from '@/pages/calendar/CalendarIndex';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { CALENDAR_PAGE_PERMISSIONS } from '@/lib/calendar-access';

export const Route = createFileRoute('/_authenticated/_app/calendar')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: [...CALENDAR_PAGE_PERMISSIONS], redirectTo: '/dashboard' }),
	component: CalendarIndex,
});
